import React, { PropsWithChildren, useEffect, useState } from 'react';
import { PinterestEmbed } from 'react-social-media-embed';


/**
 * @interface IEmbedPinterestProps declares any input properties required for this component.
 */
export interface IEmbedPinterestProps extends PropsWithChildren<unknown> {
  url: string;
  postWidth: number | string;
  postHeight: number | string;
}

/**
 * @function EmbedPinterest is a React functional component for displaying a Pinterest social media post.
 * @param {} props are the properties passed into the component.
 */
export const EmbedPinterest: React.FC<IEmbedPinterestProps> = (props: IEmbedPinterestProps) => {
  EmbedPinterest.displayName = 'EmbedPinterest';

  // whether to display console logs (displayConsoleLogs && console.log statements)
  const displayConsoleLogs: boolean = false;

  displayConsoleLogs && console.log(`EmbedPinterest. Entered EmbedPinterest`);

  const { url, postWidth, postHeight } = props;


  // The script that the react-social-media-embed component uses to load and embed Pinterest posts is apparently out of date. We will load an
  // updated Pinterest embed script (see https://louisem.com/241213/embed-pinterest-pins)
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://assets.pinterest.com/js/pinit.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
      <PinterestEmbed url={url} width={postWidth} height={postHeight} />
    </>
  )
}
